export const tags = {
  HUB: 'hub',
};
